import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "dropdown"]

  connect() {
    this.initializeColumns()
    this.loadColumnPreferences()
    this.bindOutsideClick()
  }

  disconnect() {
    this.unbindOutsideClick()
  }

  initializeColumns() {
    this.columns = Array.from(document.querySelectorAll('input[data-column]')).map(input => input.dataset.column)
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
    const expanded = this.dropdownTarget.classList.contains("hidden") ? "false" : "true"
    this.buttonTarget.setAttribute("aria-expanded", expanded)
  }

  toggleColumn(event) {
    const column = event.target.dataset.column
    const isVisible = event.target.checked

    this.setColumnVisibility(column, isVisible)
    this.saveColumnPreferences()
  }

  setColumnVisibility(column, isVisible) {
    const headers = document.querySelectorAll(`th[data-column="${column}"]`)
    const cells = document.querySelectorAll(`td[data-column="${column}"]`)

    headers.forEach(header => {
      if (isVisible) {
        header.classList.remove('hidden')
      } else {
        header.classList.add('hidden')
      }
    })

    cells.forEach(cell => {
      if (isVisible) {
        cell.classList.remove('hidden')
      } else {
        cell.classList.add('hidden')
      }
    })

    if (headers.length === 0 && cells.length === 0) {
      console.warn(`No elements found for column: ${column}`)
    }
  }

  showAll() {
    this.columns.forEach(column => {
      const checkbox = document.querySelector(`input[data-column="${column}"]`)
      if (checkbox) {
        checkbox.checked = true
        this.setColumnVisibility(column, true)
      }
    })
    this.saveColumnPreferences()
  }

  hideAll() {
    this.columns.forEach(column => {
      const checkbox = document.querySelector(`input[data-column="${column}"]`)
      if (checkbox) {
        checkbox.checked = false
        this.setColumnVisibility(column, false)
      }
    })
    this.saveColumnPreferences()
  }

  saveColumnPreferences() {
    const preferences = {}
    this.columns.forEach(column => {
      const checkbox = document.querySelector(`input[data-column="${column}"]`)
      if (checkbox) {
        preferences[column] = checkbox.checked
      }
    })
    document.cookie = `column_visibility=${JSON.stringify(preferences)};path=/;max-age=31536000`

  }

  loadColumnPreferences() {
    const cookie = this.getCookie('column_visibility')
    if (cookie) {
      try {
        const preferences = JSON.parse(cookie)
        this.applyPreferences(preferences)
      } catch (e) {
        console.error('Error loading column preferences from cookie:', e)
      }
    }
  }

  applyPreferences(preferences) {
    this.columns.forEach(column => {
      const checkbox = document.querySelector(`input[data-column="${column}"]`)
      if (checkbox && preferences.hasOwnProperty(column)) {
        checkbox.checked = preferences[column]
        this.setColumnVisibility(column, preferences[column])
      }
    })
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  bindOutsideClick() {
    this.outsideClickHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.dropdownTarget.classList.add("hidden")
        this.buttonTarget.setAttribute("aria-expanded", "false")
      }
    }
    document.addEventListener('click', this.outsideClickHandler)
  }

  unbindOutsideClick() {
    if (this.outsideClickHandler) {
      document.removeEventListener('click', this.outsideClickHandler)
    }
  }
}
